import { useState } from "react";
import { withTranslation } from "next-i18next";
import { Button, Offcanvas } from "@components/core";
import sizeTypes from "@utils/constants/sizeTypes";
import SizeEquivalenceTable from "./SizeEquivalenceTable";

function SizesGuide({ t, product }) {
  const [showSizesGuide, setShowSizesGuide] = useState(false);

  function closeSizesGuide() {
    setShowSizesGuide(false);
  }

  if (product.size_type === sizeTypes.size_tu) return null;

  return (
    <section className="mt-3">
      <Button
        variant="link-primary"
        className="no-underline"
        onClick={() => setShowSizesGuide(true)}
      >
        {t("product:size_guide_offcanvas.show_size_guide_button")}
      </Button>

      <Offcanvas
        title={t("product:size_guide_offcanvas.title")}
        show={showSizesGuide}
        onHide={closeSizesGuide}
        placement="start"
      >
        <div className="pt-5 px-4 text-center">
          <h5>{t("product:size_guide_offcanvas.subtitle")}</h5>
          <SizeEquivalenceTable sizeType={product.size_type} />
        </div>
      </Offcanvas>
    </section>
  );
};

export default withTranslation("product")(SizesGuide);